import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { timeout } from "@app/class/Utilities";
import { IVListRow } from "@directives/_veri/v-list/v-list.component";
import { IAlertResolutionCode } from "src/app/main/modules/alerts/_models/IAlertResolutionCode";
import { AlertsService } from "src/app/main/modules/alerts/_services/alerts.service";
import './resolution-code-editor.component.scss';

@Component({
    template: require('./resolution-code-editor.component.html'),
    selector: 'resolution-code-editor'
})
export class ResolutionCodeEditorComponent implements OnInit {

    @Output() add = new EventEmitter<void>();
    @Output() delete = new EventEmitter<void>();

    resolutionCode: IAlertResolutionCode;
    resolutionCodes: IVListRow<IAlertResolutionCode>[];

    resolutionCodeText: string;
    editMode = false;

    loading: boolean;
    saving: boolean;
    deleting: boolean;

    constructor(
        private readonly alertsService: AlertsService) { }

    ngOnInit(): void {
        this.loadData();
    }

    async addResolutionCode(): Promise<void> {

        if (this.saving) {
            return;
        }

        this.saving = true;

        if (this.editMode) {
            await this.alertsService.updateAlertResolutionCode(this.resolutionCode)
        } else {
            await this.alertsService.addAlertResolutionCode(this.resolutionCode)
        }

        this.add.emit();
        this.saving = false;

        this.loadData(1000);
    }

    listItemSelected(listItem: IVListRow<IAlertResolutionCode>): void {
        this.resolutionCode = listItem.data;
        this.resolutionCodeText = listItem.data.Name;
        this.editMode = true;
    }

    cancelEditMode(): void {
        this.editMode = false;
        this.resolutionCode = {
            Id: null,
            Name: '',
            AccountId: null,
            Active: true
        }
    }

    async deleteResolutionCode(confirmation: boolean): Promise<void> {

        if (this.deleting) {
            return;
        }

        if (!confirmation) {
            return;
        }

        this.deleting = true;

        this.resolutionCode.Active = false;

        await this.alertsService.updateAlertResolutionCode(this.resolutionCode);

        this.cancelEditMode();
        this.delete.emit();
        this.deleting = false;

        this.loadData(1000);
    }

    //--

    private async loadData(delay: number = 0): Promise<void> {

        if (this.loading) {
            return;
        }

        this.loading = true;

        await timeout(delay);

        this.resolutionCodes = [];

        this.resolutionCode = {
            Id: null,
            Name: '',
            AccountId: null,
            Active: true
        }

        this.alertsService.getAlertResolutionCodes({ invalidateCache: true }).then(codes => {
            codes.filter(c => c.Active).forEach(code => {
                this.resolutionCodes.push({
                    data: code,
                    id: code.Id,
                    searchString: code.Name,
                    sortData: code.Name,
                    contents: code.Name
                });
            })
        }).finally(() => {
            this.loading = false;
        })
    }
}
